(function() {
    'use strict';

    class FeedbackRequestDialogService {

        constructor($mdDialog, $translate){
            this.$mdDialog = $mdDialog;
            this.$translate = $translate;
            this.feedbackDescription = '';
        }
        feedbackRequstController() {
            this.requestPending = false;
            this.requestSuccess = false;
            this.requestModalHeader = this.$translate.instant('icm-web__profile-feedback--request-research-modal-header',{
                contactName: this.contactName
            });

            this.submitFeedback = function(){
                let payload = this.getContactPayload();
                this.requestPending = true;
                this.requestRejected = false;

                this.InfluencerContactService.submitFeedback(payload).then(function onSuccess() {
                    this.requestPending = false;
                    this.requestSuccess = true;
                }.bind(this)).catch(function onError() {
                    this.feedbackSubmissionError();
                }.bind(this)).finally(function afterAll() {
                    this.trackContactFeedbackCompleted();
                }.bind(this));
            };

            this.getContactPayload = function getContactPayload() {
                let payload = {
                    update_request: {
                        type: 'other',
                        // contact being updated
                        resource_uuid: this.contact.id,
                        // company doing the update
                        company_name: this.currentCompany.name,
                        company_id: this.currentCompany._id,
                        account_id: this.currentCompany.accountId,
                        opportunity_id: this.currentCompany.opportunityId,

                        // user doing the update
                        customer_email: this.currentUser.email,
                        user_id: this.currentUser._id,
                        language: this.currentUser.language
                    }
                };

                if (this.feedbackDescription.length > 0) {
                    payload.update_request.description = this.feedbackDescription;
                }

                return payload;
            };

            this.trackContactFeedbackCompleted = function trackContactFeedbackCompleted() {
                let data = {
                        source: 'webapp',
                        label: 'icm_contact_feedback_completed',
                        contactId: this.contact.id,
                        userId: this.currentUser.email + ' (' + this.currentUser._id + ') ' + this.currentCompany.name
                    },
                    feedbackData = {
                        type: 'incorrect',
                        description: this.feedbackDescription || 'No description'
                    };
                this.AnalyticsService.trackFeedbackLoop('completed', data, feedbackData);
            }.bind(this);

            this.feedbackSubmissionError = function feedbackSubmissionError() {
                this.errorMessage = this.$translate.instant('icm-web__profile-feedback--error-text');
                this.requestPending = false;
                this.requestRejected = true;
            }.bind(this);
        }

        showRequestDialog(vars){
            this.$mdDialog.show(
                this.$mdDialog.mwMiniModal({
                    locals: vars,
                    controller: this.feedbackRequstController,
                    templateUrl: 'icm-web/views/feedback_request_modal',
                    controllerAs: '$ctrl'
                })
            );
        }
    }

    angular.module('MW.Influencers.FeedbackRequestDialogService', [
        'ngMaterial',
        'ngMessages',
        'mwAppComponents'
    ])
        .service('FeedbackRequestDialogService', [
            '$mdDialog',
            '$translate',
            FeedbackRequestDialogService]);
})();